import BookSlotForm from "../BookSlotForm";

import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./BookTrialClassForm.module.scss";

interface BookTrialClassFormProps {
  standalone?: boolean;
}

const BookTrialClassForm: React.FC<BookTrialClassFormProps> = ({
  standalone,
}) => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { currencySymbol, price, formSection } = data?.trialData || {};
  const { imageUrl, label, prefix, background } = formSection || {};

  return (
    <div
      className={clsx(
        cls("bookTrialClassForm"),
        standalone ? cls("standalone") : ""
      )}
    >
      <div className={cls("bookTrialClassFormWrapper")}>
        <Typography
          variant="paragraph1"
          className={cls("prefixHeading")}
          dangerouslySetInnerHTML={{ __html: prefix }}
        />
        {imageUrl ? (
          <div
            style={{ background }}
            className={cls("nutritionistImageContainer")}
          >
            <img
              src={imageUrl}
              alt="nutritionist image"
              className={cls("nutritionistImage")}
            />
            <div className={cls("heading")}>
              <Typography
                variant="paragraph1"
                className={cls("prefix")}
                dangerouslySetInnerHTML={{ __html: prefix }}
              />
             {currencySymbol &&  price !== null && <Typography
                variant="paragraph1"
                className={cls("priceLabel")}
                dangerouslySetInnerHTML={{
                  __html: `${label} <strong>${currencySymbol}&nbsp;${price}</strong>`,
                }}
              />}
            </div>
          </div>
        ) : (
          <div className={cls("header")}>
            <Typography
              variant="paragraph1"
              className={cls("prefix")}
              dangerouslySetInnerHTML={{ __html: prefix }}
            />
            {currencySymbol &&  price !== null && <Typography
              variant="heading2"
              className={cls("title")}
              dangerouslySetInnerHTML={{
                __html: `${label} <strong>${currencySymbol}&nbsp;${price}</strong>`,
              }}
            />}
          </div>
        )}
        <BookSlotForm
          showModal={{
            packageData: data?.trialData,
          }}
        />
      </div>
    </div>
  );
};

export default BookTrialClassForm;
